<template>
  <iframe
    :src="viewerUrl"
    class="pdf-frame"
    frameborder="0">
  </iframe>
</template>

<script>
export default {
  name: "PdfViewer",
  props: {
    pdf: {
      type: String,
      required: true
    }
  },
  computed: {
    viewerUrl() {
      // Muy importante: usar encodeURIComponent
      return `/pdfjs/web/viewer.html?file=${encodeURIComponent(this.pdf)}`;
    }
  }
};
</script>

<style scoped>
.pdf-frame {
  width: 100%;
  height: 95vh;
  border: none;
}
</style>